import Content from "uxp-documentation/src/pages/uxp-api/reference-spectrum/Typography/sp-body";
import * as React from 'react';
export default {
  Content,
  React
};